import { removeSpaceAfter } from './stringUtils';
import _filter from 'lodash/filter';
import dayjs from 'dayjs';
import { CYOA_NETWORK_IDS } from '../config';


//list of cities
export const cityList = (trips) => {

  let sectors = [];

  const isCyoa = _filter(trips, (o) => {return o.tour_id === CYOA_NETWORK_IDS["europe"].id || o.tour_id === CYOA_NETWORK_IDS["usa"].id});

  
  if(isCyoa.length > 0){
    sectors.push({
      tour_id:isCyoa[0].tour_id,
      city:trips[0].passengers[0].reservations[0].start_city,
      date_for:removeSpaceAfter(trips[0].passengers[0].reservations[0].date_for),
      reservations:trips[0].passengers[0].reservations[0]
    })

    for(var ii = 0; ii < trips.length; ii++){
      for(var jj = 0; jj < trips[ii].passengers[0].reservations.length; jj++){
        sectors.push({
          tour_id:trips[ii].tour_id,
          city:(trips[ii].tour_id === CYOA_NETWORK_IDS["europe"].id || trips[ii].tour_id === CYOA_NETWORK_IDS["usa"].id ) ? trips[ii].passengers[0].reservations[jj].end_city : trips[ii].tour_name,
          date_for:removeSpaceAfter(trips[ii].passengers[0].reservations[jj].date_for),
          reservations:trips[ii].passengers[0].reservations[jj]
        });
      }

    }
  }
  return sectors;
}

//calculate cit duration
export const cityDuration = (trip) => {
  let duration = 0;
  for(let i = 0; i < trip.length-1; i++){
    duration += dayjs(trip[i+1].date_for).diff(dayjs(trip[i].date_for), 'days')
  }
  return duration;
}



// WEBPACK FOOTER //
// ./src/helpers/cyoaHelper.js